import CustomLink from "@/lib/tiptapLink";
import Bold from "@tiptap/extension-bold";
import { Color } from "@tiptap/extension-color";
import FontFamily from "@tiptap/extension-font-family";
import { Heading } from "@tiptap/extension-heading";
import Highlight from "@tiptap/extension-highlight";
import Image from "@tiptap/extension-image";
import Paragraph from "@tiptap/extension-paragraph";
import Placeholder from "@tiptap/extension-placeholder";
import Table from "@tiptap/extension-table";
import TableCell from "@tiptap/extension-table-cell";
import TableHeader from "@tiptap/extension-table-header";
import TableRow from "@tiptap/extension-table-row";
import TextAlign from "@tiptap/extension-text-align";
import TextStyle from "@tiptap/extension-text-style";
import Underline from "@tiptap/extension-underline";
import StarterKit from "@tiptap/starter-kit";

const createEditorExtensions = () => [
    StarterKit,
    Paragraph,
    Bold,
    Color,
    FontFamily,
    Heading,
    Highlight,
    Image,
    CustomLink,
    Placeholder.configure({
        placeholder: "",
    }),
    Table,
    TableCell,
    TableHeader,
    TableRow,
    TextAlign.configure({
        types: ["paragraph"],
    }),
    TextStyle,
    Underline,
];

export default createEditorExtensions;
